"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _changeFlow = require("./changeFlow");
Object.keys(_changeFlow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeFlow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeFlow[key];
    }
  });
});